import { ProfileBookingRequestStatusEnum } from '../enums/profile-booking-request-status.enum';

export function normalizeProfileBookingRequestStatus(status: string | null | undefined): string | null | undefined {
    if (!status) {
        return status;
    }

    if (status === ProfileBookingRequestStatusEnum.TRANSFERRED) {
        return ProfileBookingRequestStatusEnum.CANCELED_BY_TRANSFER;
    }

    return status;
}

export function isCanceledByTransferStatus(status: string | null | undefined): boolean {
    return normalizeProfileBookingRequestStatus(status) === ProfileBookingRequestStatusEnum.CANCELED_BY_TRANSFER;
}
